// extracted by mini-css-extract-plugin
module.exports = {"outer":"_21giB","modalOuter":"zX0kD","bottomContainer":"_3Fior","panelWrapper":"CVTqP","heading":"_2gWLC","subHeading":"_3BMny"};